export const DEFAULT_DROPDOWN_PLACEHOLDER = 'Select a value';
export const PROGRAM_ELIGIBILITY_LISTS = [
  { name: 'Home Health', value: 'HH', program: 'stars-status-canceled' },
  { name: 'PAC IM', value: 'PAC', program: 'stars-status-canceled' },
  { name: 'SDoH', value: 'SDoH', program: 'stars-status-canceled' },
  { name: 'STARs', value: 'Stars', program: 'stars-status-canceled' },
  { name: 'Wound Care Connect', value: 'Wound Care Connect', program: 'stars-status-canceled' },
  { name: 'PAC Commercial', value: 'PAC Commercial', program: 'stars-status-canceled' },
  { name: 'DMEPOS', value: 'DMEPOS', program: 'stars-status-canceled' }
];
